<template>
    <div class="page-wrapper footer">
        <div class="page-content" style="background:none;" >
            <div class="footer-container">
                <div class="footer-content">
                    <!--  -->
                    <div>
                        <div style="margin-bottom:60px;"><img :src="logoImg" style="width:180px;" /></div>
                        <div style="margin-bottom:20px;">
                            <div>服务热线</div>
                            <div style="color:#fff; font-size:24px; line-height:46px; ">13923654388</div>
                        </div>
                        <!-- <div style="line-height:32px;">
                            <span>电话：</span>
                            <span style="color:#fff; font-weight:bold;">13923654388</span>
                        </div> -->
                        <div style="line-height:32px;">广东·惠州仲恺高新区仲恺大道（惠环段）448号同方信息港大厦8层04号房</div>
                    </div>
                    <!-- 导航区 -->
                    <div
                        v-for="(item, index) in menuData"
                        :key="index"  
                        style="cursor:pointer;" 
                    >
                        <div style="font-size:16px; line-height:22px; font-weight:bold; color:#fff; margin-bottom:40px; " @click="handleParent(item.path)">{{ item.title }}</div>
                        <div>
                            <div
                                v-for="(sub, j) in item.children"
                                :key="index-j"
                                style="line-height:36px;cursor:pointer;"
                                @click="handleParent(sub.path, sub.params)"
                            >
                                {{ sub.title }}
                            </div>
                        </div>
                    </div>
                    <!-- 公众号 -->
                    <div>
                        <div><img :src="codeImg" /></div>
                        <div style="line-height:18px;">关注华翊智能微信公众号</div>
                    </div>
                </div>
                <!--  -->
                <div style="height:60px; line-height:60px; border-top:1px solid #2B303B;"><span>广东华翊智能科技有限公司   <a href="https://beian.miit.gov.cn" _blank style="color:#99A0AE">粤ICP备20066003号-9</a></span></div>
            </div>
            
        </div>
    </div>
</template>
<script>
    import { useRouter } from 'vue-router';
    import { markAction } from '@/api/global.js';
    import logoImg from '@/assets/logo_white.png';
    import codeImg from '@/assets/code.png';
    const menuData = [
        { title:'首页', path:'/', children:[{ title:'iFMCS 介绍', path:'/?pos=0' }, { title:'小易 Ai', path:'/?pos=1480' }, { title:'案例', path:'/?pos=3480' }, { title:'资讯', path:'/?pos=4940' }]},
        { title:'产品中心', path:'/product', children:[{ title:'应用产品', path:'/product' }, { title:'服务产品', path:'/product?type=service' }, { title:'AI Agent产品', path:'/product?type=algorithm' }, { title:'硬件产品', path:'/product?type=hardware' }]},
        { title:'成功案例', path:'/case', children:[{ title:'能源案例', path:'/case'}, { title:'安防案例', path:'/case?type=智慧安全'}, { title:'环境案例', path:'/case?type=智慧环境'}, { title:'运维案例', path:'/case?type=智慧运维' }]},
        { title:'生态合作', path:'/teamwork', children:[{ title:'合作方式', path:'/teamwork' }, { title:'合作优势', path:'/teamwork' }, { title:'合作流程', path:'/teamwork'}]},
        { title:'开放平台', path:'/open',  children:[{ title:'应用接入', path:'/open'}, { title:'服务接入', path:'/open' }, { title:'AI Agent接入', path:'/open' }, { title:'硬件接入', path:'/open' }]},
        { title:'关于我们', path:'/about', children:[{ title:'公司简介', path:'/about' }, { title:'发展历程', path:'/about' }, { title:'公司资讯', path:'/about'}, { title:'联系方式', path:'/about' }]},
    ];
    export default {
        props:{
            'onScroll':{ type:Function }
        },
        data(){
            return {
                logoImg,
                codeImg,
                menuData
            }
        },
        methods:{
            handleParent( path, params){
                if ( path === '/open') {
                    markAction({ operationType:'进入开放平台' });
                    window.open('http://open.ifmcs.com', '__blank');
                } else {      
                    this.$router.push(path);           
                }
            }
        }
    }
   
</script>
<style scoped>
    .footer {
        height:386px;
        background:#0E121B;
    }
    .footer-container {
        padding:50px 20px 0 20px;
        color:#99A0AE;
    }
    .footer-content {
        height:275px;
        display:flex;
        justify-content: space-between;
        align-items: flex-start;
        font-size:14px;
    }
</style>

